import { render, staticRenderFns } from "./AppAutoUpload.vue?vue&type=template&id=48e6b60c"
import script from "./AppAutoUpload.vue?vue&type=script&lang=js"
export * from "./AppAutoUpload.vue?vue&type=script&lang=js"
import style0 from "./AppAutoUpload.vue?vue&type=style&index=0&id=48e6b60c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports